import { Theme } from 'config';

const styles = (theme: Theme) => ({
  charts: {
    padding: '3em 0 !important',
    margin: '0 auto 2.25rem !important',
    background: '#f4f6f8 !important',
    borderRight: '7.5em solid white',
    borderLeft: '7.5em solid white',

    '&.batchMode': {
      border: '0 !important',
      minHeight: '66.750rem !important',
      paddingTop: '10.650rem !important',
      margin: '0 !important',
      width: '100% !important',
    },
    '& .statistic': {
      width: '100% !important',
    },
  },
  label: {
    marginBottom: '1rem !important',
    color: '#75797b !important',
    fontWeight: '500 !important',
    textTransform: 'none !important',
    fontSize: '1em !important',

    '&.white': {
      color: '#fff !important',
    },

    '&.center': {
      textAlign: 'center !important',
    },
  },
  value: {
    color: `${theme.violet} !important`,
    marginBottom: '.250rem !important',
    textTransform: 'none !important',
    fontSize: '1.250em !important',
    fontWeight: '300 !important',

    '& span': {
      fontWeight: '300 !important',
    },

    '&.green': {
      color: `${theme.seafoamGreen} !important`,
    },

    '&.white': {
      color: `#ffffff !important`,
    },

    '&.center': {
      textAlign: 'center !important',
    },
    '&.dateRange': {
      fontSize: '2.75rem !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'center !important',
    },
  },
  subtitleBlock: {
    paddingLeft: '0.875rem !important',
  },
  leftBlock: {
    padding: '4rem !important',
    borderRight: '0.150rem dotted #AAA',

    '&.middle': {
      borderTop: '0.150rem dotted #AAA',
      padding: '4rem 0 !important',
    },
    '&.bottom': {
      padding: '4rem 0 0 0 !important',
      borderTop: '0.150rem dotted #AAA',
    },
  },
  rightBlock: {
    padding: '4rem 2rem !important',

    '&.middle': {
      borderTop: '0.150rem dotted #AAA',
    },
    '&.bottom': {
      borderTop: '0.150rem dotted #AAA',
    },
  },
  topHighlightedBlock: {
    textAlign: 'center',
    background: theme.violet,
    padding: '1.450rem 0 !important',
  },
  highlightedBlock: {
    textAlign: 'center',
    background: theme.violet,
    padding: '0.250rem 0 !important',
  },
  noPadding: {
    padding: '0 !important',
  },
  noMargin: {
    margin: '0 !important',
  },
});

export default styles;
